import clsx from "clsx";
import styles from "./Spinner.module.css";

export interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  /** Announced to screen readers; pass null when a surrounding element already says "Saving…". */
  label?: string | null;
  className?: string;
}

/** Inline progress for buttons and small regions. Use Skeleton for content-shaped loading. */
export function Spinner({ size = "sm", label = "Loading…", className }: SpinnerProps) {
  return (
    <span className={clsx(styles.spinner, className)} data-size={size} role={label ? "status" : undefined}>
      <svg className={styles.svg} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle className={styles.track} cx="12" cy="12" r="9" />
        <path className={styles.arc} d="M21 12a9 9 0 0 0-9-9" />
      </svg>
      {label ? <span className={styles.label}>{label}</span> : null}
    </span>
  );
}
